import { FormBase } from 'core/components';

export default class AmazonTemplatesForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'defaultPrimeTemplate',
				'amazonTemplates',
				'amazonTemplates[].systemCode',
				'amazonTemplates[].amazonCode',
			],
			labels: {
				defaultPrimeTemplate: 'AMAZONTEMPLATES.DEFAULTPRIMETEMPLATE',
				'amazonTemplates[].systemCode': '',
				'amazonTemplates[].amazonCode': '',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/AmazonTemplatesForm.js